import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const BaseButton = ({
  title,
  onClick,
  img,
  style,
  disabled,
}) => (
  <button
    className={`button-base ${disabled ? 'button-base__disabled' : ''}`}
    style={style}
    onClick={disabled ? (e) => { e.preventDefault(); } : onClick}
  >
    {img && <img src={img} alt="" />}
    <span>{title}</span>
  </button>
);

BaseButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  img: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

BaseButton.defaultProps = {
  img: null,
  style: {},
  disabled: false,
};

export default BaseButton;



// WEBPACK FOOTER //
// ./src/components/ui/Buttons/BaseButton/index.js